import useSWRMutation from 'swr/mutation';

// this key is scoped to the LangSmith Unsubscribe Reasons base with
// scope: data.records:write
const AIRTABLE_API_KEY = import.meta.env.VITE_AIRTABLE_WRITE_KEY;
const BASE_ID = 'appmAaAhiYPlT6ijO';
const AIRTABLE_FORM_ID = 'tblceSy1SoW7P0tdv';

const AIRTABLE_URL = `https://api.airtable.com/v0/${BASE_ID}/${AIRTABLE_FORM_ID}`;

export enum FormFieldIds {
  Email = 'fldYQK4xBn24fRqR1',
  OrgId = 'fldM5XCSSQupuGqSj',
  Reasons = 'fldlbz1AQhTkkXcrO',
  ExtraDetails = 'fldhZWCXgIR2NreiV',
  OtherReason = 'fldolcPS9ZthLJXlj',
}

type SubscriptionCancellationForm = {
  [FormFieldIds.Email]: string;
  [FormFieldIds.OrgId]: string;
  [FormFieldIds.Reasons]: string[];
  [FormFieldIds.ExtraDetails]: string;
  [FormFieldIds.OtherReason]: string;
};

export const useSubmitSubscriptionCancellationForm = () => {
  return useSWRMutation(
    AIRTABLE_URL,
    (url, { arg }: { arg: SubscriptionCancellationForm }) => {
      const body = {
        records: [{ fields: arg }],
      };
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          Authorization: `Bearer ${AIRTABLE_API_KEY}`,
          'Content-Type': 'application/json',
        },
      });
    }
  );
};
